type Props = {
  text: string
}

export const LightHeading = ({ text }: Props): JSX.Element => (
  <div className="text-[3.2vw] lg:text-[1.4vw] font-bold tracking-[0.3vw] lg:tracking-[0.1vw] text-[#8B8B8B]">
    <h2>{text}</h2>
  </div>
)
